import "../base.js";
import "../mixins/conditional_visibility.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};
window.AppointmentBooking.Wizard.Views.Summary ??= {};

AppointmentBooking.Wizard.Views.Summary.Item = class Item extends (
  AppointmentBooking.Wizard.Views.Mixins.ConditionalVisibilty(AppointmentBooking.Wizard.Views.Base)
) {};
AppointmentBooking.Wizard.Views.Summary.Item.prototype.tagName = "div";
AppointmentBooking.Wizard.Views.Summary.Item.prototype.className = "appointment-booking-wizard-summary-item";
AppointmentBooking.Wizard.Views.Summary.Item.prototype.template = false;
